import { ReactNode } from 'react';

interface Props {
  icon?: ReactNode;
  htmlFor?: string;
  children: ReactNode;
}

export function FieldLabel({ icon, htmlFor, children }: Props) {
  return (
    <label
      htmlFor={htmlFor}
      className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-[var(--t3,rgba(15,30,51,0.42))] mb-1.5"
    >
      {icon && (
        <span style={{ display: 'inline-flex', width: '12px', height: '12px' }} aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </label>
  );
}
